import { makeStyles } from '@material-ui/core/styles';

export const useStylesTabs = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    minHeight: 0,
    margin: '20px 0',
    backgroundColor: theme.colors.dark.darkSlateGray,
    '& .MuiTab-textColorInherit.Mui-selected': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
  indicator: {
    backgroundColor: 'transparent',
  },
}));

export const useStylesTab = makeStyles(theme => ({
  root: {
    minWidth: 100,
    minHeight: 0,
    height: 36,
    marginRight: 4,
    paddingTop: 10,
    fontSize: 16,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontFamily: 'Roboto',
    color: theme.colors.light.freshPowder,
    borderRadius: 10,
    backgroundColor: theme.colors.dark.midnightBlue,
  },
}));
